module.exports = __webpack_public_path__ + "img/notreductiontargeticon.855974c8.svg";